import { cancel, put, select, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  PreiseStreckeErmittelt,
} from '@ps20-frontend/shop-integration-redux';
import { App, Produktlinie } from '@ps20-frontend/frontend-models';
import { Produktlinienname } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { ZusatzoptionenNameVHVEnum } from '../model/zusatzoptionenVHV.model';
import { VhvActions } from '../vhvActions';
import { VersicherungsSummeGrenzen } from '../model/versicherungssummen';
import { activateProduktlinie } from './produktlinienSaga';

//TODO: Fast identisch zur Saga in VWG
export function* extremwetterschutzVorbelegenSaga() {
  yield takeEvery(
    GlobalActions.PREISE_STRECKE_ERMITTELT,
    safeSaga(handleProduklinienAnpassungen, App.VHV_V2),
  );
}

export function* handleProduklinienAnpassungen(action: GlobalAction<PreiseStreckeErmittelt>) {
  const state: IAppState = yield select();
  if (
    action.payload.appId !== App.VHV_V2 ||
    action.payload.angebotsId !== state.angebotsId ||
    state.vertragsoptionen?.beibehalten
  ) {
    yield cancel();
  }

  let produktlinien = state.produkt.produktlinien;
  const staendigBewohnt: boolean = state.versObjekt.staendigBewohnt;
  const versicherungssummeLinieXl = state.versicherungssummen.find(
    versicherungssumme => versicherungssumme.produktlinie === Produktlinienname.PREMIUM,
  );
  let zusatzoptionenChanged = false;
  [produktlinien, zusatzoptionenChanged] = extremwetterschutzVorbelegen(produktlinien);

  if (
    versicherungssummeLinieXl?.summe <= VersicherungsSummeGrenzen.MAX_VERSSUMME &&
    staendigBewohnt && state.versObjekt?.wohnflaeche >= 80
  ) {
    activateProduktlinie(produktlinien, Produktlinienname.PREMIUM);
    yield put(new VhvActions().produktlinienChanged(produktlinien));
  } else if (zusatzoptionenChanged) {
    yield put(new VhvActions().produktlinienChanged(produktlinien));
  }

  if (zusatzoptionenChanged && state.wertsachensummen) {
    yield put(new VhvActions().requestPreis());
  }
}

export function extremwetterschutzVorbelegen(
  produktlinien: Array<Produktlinie>,
): [Array<Produktlinie>, boolean] {
  const selectedProduktlinie = produktlinien.find(produktlinie => produktlinie.selected);

  if (selectedProduktlinie == undefined) {
    return [produktlinien, false];
  }

  const extremwetterschutzZusatzoption = selectedProduktlinie.zusatzoptionen.find(
    zusatzoption => zusatzoption.name == ZusatzoptionenNameVHVEnum.ELEMENTAR,
  );
  if (
    extremwetterschutzZusatzoption == undefined ||
    extremwetterschutzZusatzoption.disabled === false
  ) {
    return [produktlinien, false];
  }

  if (!extremwetterschutzZusatzoption.isSelected) {
    const newProduktLinien = produktlinien.map(produktlinie => {
      produktlinie.zusatzoptionen = produktlinie.zusatzoptionen.map(zusatzoption => {
        if (zusatzoption.name === ZusatzoptionenNameVHVEnum.ELEMENTAR) {
          return { ...zusatzoption, isSelected: true, disabled: false };
        }
        return zusatzoption;
      });
      return produktlinie;
    });
    return [newProduktLinien, true];
  }

  return [produktlinien, false];
}
